import React , {useEffect} from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { routes } from './routeConfig';
import MainLayout from './Layouts/Main';
import GA from './GoogleAnalytics'
import './App.scss';

function App() {

  return (
    <BrowserRouter>
      <div className="App">
        <MainLayout>
          { GA.init() }
          <Switch>
            { Object.values(routes).map(route => 
                <Route 
                  path={route.path}
                  key={route.title}
                  exact={route.exact}
                  component={route.content}
                >
                </Route>
              )
            }
          </Switch>
        </MainLayout>
      </div>
    </BrowserRouter>
  );
}

export default App;
